import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-ink py-12 text-cream/70" data-id="element-105" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-106" data-mp="3gh3n22klrk9c">
        <p className="font-serif text-xl font-semibold text-cream" data-id="element-107" data-mp="32p5qer82vgu2">
          Yoga 360™ by RecursosFitness™
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-cream/60" data-id="element-108" data-mp="36nd4tff2k623">
          El sistema completo para instructoras de Yoga que quieren enseñar con más claridad,
          seguridad y profesionalismo.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm" data-id="element-109" data-mp="3lem1g8he2roq">
          <span className="inline-flex items-center gap-1.5" data-id="element-110" data-mp="3qd6r5dz0lsyx">
            <MailIcon className="h-4 w-4" data-id="element-111" data-mp="3qblxrrofsg2n" /> contacto@recursosfitness.shop
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-112" data-mp="29xm0ypkw16jm">
            <InstagramIcon className="h-4 w-4" data-id="element-113" data-mp="2eyjrpqjyr8wq" /> @recursosfitness.ar
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-114" data-mp="3l9abhd1s8u1s">
            <GlobeIcon className="h-4 w-4" data-id="element-115" data-mp="3lbmt1p3mp2eb" /> recursosfitness.shop
          </span>
        </div>

        <p className="mx-auto mt-8 max-w-2xl border-t border-white/10 pt-6 text-xs leading-relaxed text-cream/40" data-id="element-116" data-mp="3gca674crbvbq">
          © RecursosFitness.shop™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}